import React from 'react';
import * as Yup from 'yup';
import { Form, Formik } from 'formik';
import { Box, Grid } from '@mui/material';
import { ManageAccounts } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import CustomSubmitButton from '../../../components/Forms/CustomSubmitButton';
import CustomTextField from '../../../components/Forms/CustomTextField';
import useRTK from '../../../hooks/useRTK';
import { setUserProfile } from '../../../states/features/profile/profileSlice';
import { useUpdateORGEmailMutation } from '../../../api/profile/profileAPI';

// ################## VALIDATION ####################
// * -> email
const emailValidationSchema = Yup.object({
    email: Yup.string()
        .required('Organization email is required field')
        .email('Email field should contain a valid e-mail'),
});

// !############## MAIN FUNC ################
const UpdateEmail = ({ user, closeDialogy, refetchProfile }) => {
    // ################# CONST ##################
    const RTK = useRTK();
    const dispatch = useDispatch();

    // ############### RTK #####################
    const [
        updateORGEmail,
        { isLoading, isSuccess, isError, error, data: updatedData },
    ] = useUpdateORGEmailMutation();

    // ############### useEffect ################
    // => RTK action
    const rtkActions = (data) => {
        closeDialogy();
        refetchProfile();
        dispatch(setUserProfile(data));
    };
    RTK.useRTKResponse(isSuccess, isError, error, updatedData, rtkActions);

    return (
        <>
            <Formik
                initialValues={{
                    email: user.email,
                }}
                validationSchema={emailValidationSchema}
                onSubmit={(payload) => {
                    updateORGEmail(payload);
                }}
            >
                {(formik) => (
                    <Form>
                        <Grid container justifyContent={'center'}>
                            <Grid item sm={12} xs={12} padding={1}>
                                <CustomTextField
                                    name="email"
                                    className="form-input"
                                    label={`${user.organization_type.name} email`}
                                    type="email"
                                />
                            </Grid>
                            <Grid item sm={12} xs={12}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                    }}
                                >
                                    <CustomSubmitButton
                                        startIcon={<ManageAccounts />}
                                        onClick={formik.handleSubmit}
                                        loading={isLoading}
                                    >
                                        Update email
                                    </CustomSubmitButton>
                                </Box>
                            </Grid>
                        </Grid>
                    </Form>
                )}
            </Formik>
        </>
    );
};

export default UpdateEmail;
